import { Container, Divider, Skeleton, Typography } from "@mui/material";
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { formatDuration, formatUSPhoneNumber, getData, to12Hour } from "../utilities/utils";
import Grid from "../components/Grid";
import Flexbox from "../components/Flexbox";
import React, { useEffect, useState } from "react";
import cookies from "../utilities/Cookies";
import { updatedarkmode } from "../features/mode";
import { useDispatch } from "react-redux";
import Mode from "../components/styles/Mode";
import Spacebox from "../components/Spacebox";
import { CallMade, Person } from "@mui/icons-material";
import { isMobile } from "react-device-detect";

const CallLogs = ({ title }) => {
    document.querySelector('title').innerHTML = title

    const { contact_id } = useParams()
    const dispatch = useDispatch()

    const { data: call_logs, isLoading, isError, error } = useQuery({
        queryFn: () => getData(`/api/calls/logs/${contact_id}`),
        queryKey: ['call_logs', contact_id],
        staleTime: 60 * 60 * 1000 // 1 hour
    })

    const [selectedLogs, setSelectedLogs] = useState(null)
    const [owner, setOwner] = useState(null)

    const [openId, setOpenId] = useState(0)


    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (call_logs) {
            if (call_logs?.logs.length > 0)
                setSelectedLogs(call_logs?.logs[0])
            setOwner(call_logs?.owner)
        }
    }, [call_logs])

    return (
        <Mode>
            <div className="call-logs">
                <Container>
                    {isLoading && (
                        <div style={{ height: '95dvh', padding: '20px' }}>
                            <Grid grid={4} gap="10px">
                                <div className="log-details" style={{ gridColumn: '1/4' }}>
                                    <Skeleton variant="rounded" width={"100%"} height={"90dvh"} />
                                </div>
                                <div className="caller-details" style={{ gridColumn: '4/5' }}>
                                    <Skeleton variant="rounded" width={"100%"} height={"90dvh"} />
                                </div>
                            </Grid>
                        </div>
                    )}

                    {isError && !call_logs && (
                        <Flexbox alignItems="center" justifyContent="center" style={{ height: '90dvh' }}>
                            <Flexbox justifyContent="center" alignItems="center">
                                <p className="bold">Opps</p>
                                <Spacebox padding="5px" />
                                <Divider orientation="vertical" flexItem />
                                <Spacebox padding="5px" />
                                <small className="text-red red-text">
                                    {error.message}
                                </small>
                            </Flexbox>
                        </Flexbox>
                    )}

                    {call_logs && !isError && (
                        <div>
                            <Grid grid={isMobile ? 1 : 4} gap="0px">
                                <div className="log-details" style={{ gridColumn: isMobile ? '1/1' : '1/4', background: '#e1e1e1', height: '100dvh', overflowY: 'scroll' }}>
                                    <div style={{ padding: '10px', borderBottom: '1px solid #55555550' }}>
                                        <Flexbox alignItems="center" >
                                            <CallMade style={{ width: '30px' }} />
                                            <Spacebox padding="5px" />
                                            <span>Call Logs</span>
                                        </Flexbox>
                                    </div>
                                    {!selectedLogs && (
                                        <div className="" style={{ padding: '20px', borderBottom: '1px solid #55555550' }}>
                                            <Flexbox alignItems="center" justifyContent="center" style={{ minHeight: '20dvh', padding: '10px' }}>
                                                <small style={{ opacity: .7 }}>Please select a log to display recording details</small>
                                            </Flexbox>
                                        </div>
                                    )}
                                    {(selectedLogs) && <div className="" style={{ padding: '20px', borderBottom: '1px solid #55555550' }}>
                                        <Flexbox alignItems="center" justifyContent="center" style={{ minHeight: '20dvh', padding: '10px' }}>
                                            <div style={{ width: '100%' }}>
                                                <Typography className="bold heading" style={{ fontSize: '24px', textAlign: 'center' }}>
                                                    {owner.first_name} {owner.last_name}
                                                </Typography>
                                                <Spacebox padding="2px" />
                                                <div style={{ textAlign: 'center' }}>
                                                    <small style={{ opacity: .5 }}>
                                                        {(new Date(selectedLogs.start_timestamp)).toString().substring(0, 16)}, {to12Hour(new Date(selectedLogs.start_timestamp).toString().substring(16, 21))} | {selectedLogs.direction} call | {formatDuration(selectedLogs.call_cost.total_duration_seconds)}
                                                    </small>
                                                </div>
                                                <Spacebox padding="20px" />
                                                <Flexbox alignItems="center" justifyContent="center">
                                                    <audio src={selectedLogs.recording_url} controls></audio>
                                                </Flexbox>
                                                <Spacebox padding="10px" />
                                                <Flexbox alignItems="center" justifyContent="flex-end">
                                                    <div style={{ width: '15px', height: '15px', background: 'white', borderRadius: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <div style={{ width: '7px', height: '7px', background: 'red', borderRadius: '100px' }}></div>
                                                    </div>
                                                    <Spacebox padding="5px" />
                                                    <small style={{ opacity: .7 }}>Recording <b>{formatDuration(selectedLogs.call_cost.total_duration_seconds)} s</b></small>
                                                </Flexbox>
                                            </div>
                                        </Flexbox>
                                    </div>}
                                    {call_logs.logs.length > 0 && (
                                        <div style={{ padding: '20px' }}>
                                            <p className="bold heading">Interaction History</p>
                                            <Spacebox padding="10px" />
                                            <table>
                                                <thead>
                                                    <tr style={{ marginBotom: '5px' }}>
                                                        <th style={{ textAlign: 'left' }}>Agent</th>
                                                        <th>Date</th>
                                                        <th>Time</th>
                                                        <th>Duration</th>
                                                        <th>Contact Number</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {call_logs.logs.map((log, i) => {

                                                        const isOpen = openId === i

                                                        return (
                                                            <React.Fragment key={i}>
                                                                <tr onClick={() => {
                                                                    setOpenId(i)
                                                                    setSelectedLogs(log)
                                                                }} style={{ cursor: 'pointer', transition: '.5s ease', background: openId === i ? '#82b3e5ff' : 'transparent' }}>
                                                                    <td style={{ textAlign: 'left' }}>
                                                                        <small>{log?.agent_name}</small>
                                                                    </td>
                                                                    <td>
                                                                        <small>{new Date(log?.start_timestamp).toString().substring(0, 16)}</small>
                                                                    </td>
                                                                    <td>
                                                                        <small>{to12Hour(new Date(log?.start_timestamp).toString().substring(16, 21))}</small>
                                                                    </td>
                                                                    <td>
                                                                        <small>{formatDuration(log?.call_cost.total_duration_seconds)}</small>
                                                                    </td>
                                                                    <td>
                                                                        <small>{formatUSPhoneNumber(log?.to_number)}</small>
                                                                    </td>
                                                                    <td>
                                                                        <small>{log?.call_status}</small>
                                                                    </td>
                                                                </tr>
                                                                {isOpen && (
                                                                    <tr style={{ background: 'white' }}>
                                                                        <td colSpan={6}>
                                                                            <Grid grid={3} gap="10px">
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Agent ID</b><br /> {log?.agent_id}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Agent Name</b><br /> {log?.agent_name}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Agent Version</b><br /> {log?.agent_version}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Direction</b><br /> {log?.direction}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Call ID</b><br /> {log?.call_id}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Call Status</b><br /> {log?.call_status}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Call Success</b><br /> {log?.call_success ? "Yes": "No"}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Call Type</b><br /> {log?.call_type}</small>
                                                                                </div>
                                                                                {log?.direction === 'outbound' && <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>From Number</b><br /> {log?.from_number}</small>
                                                                                </div>}
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Voicemail</b><br /> {log?.in_voicemail ? 'Yes': "No"}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Start Time</b><br /> {new Date(log?.start_timestamp).toString().substring(0, 21)}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>End Time</b><br /> {new Date(log?.end_timestamp).toString().substring(0, 21)}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>User Sentiment</b><br /> {log?.user_sentiment}</small>
                                                                                </div>
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Call Summary</b></small>
                                                                                    <div style={{ maxHeight: '100px', overflowY: 'scroll', background: '#55555520', padding: '10px', marginTop: '10px' }}>
                                                                                        <small>{log?.call_summary}</small>
                                                                                    </div>
                                                                                </div>
                                                                                {log?.transcript && <div style={{ textAlign: 'left' }}>
                                                                                    <small><b>Call Transcript</b></small>
                                                                                    <div style={{ maxHeight: '100px', overflowY: 'scroll', background: '#55555520', padding: '10px', marginTop: '10px' }}>
                                                                                        <small dangerouslySetInnerHTML={{ __html: log?.transcript.replaceAll('User:', '<br/><b>User:</b>').replaceAll('Agent:', '<br /><b>Agent:</b>').replace('<br /><b>Agent:</b>', '<b>Agent:</b>') }}></small>
                                                                                    </div>
                                                                                </div>}

                                                                            </Grid>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    {call_logs.logs.length === 0 && (
                                        <Flexbox alignItems="center" >
                                            <small>this user has no call Logs</small>
                                        </Flexbox>
                                    )}
                                </div>
                                {!isMobile && <div className="caller-details" style={{ gridColumn: '4/5', background: '#f1f1f1', borderLeft: '1px solid #55555550' }}>
                                    <div style={{ padding: '10px', borderBottom: '1px solid #55555550' }}>
                                        <Flexbox alignItems="center" >
                                            <Person style={{ width: '30px' }} />
                                            <Spacebox padding="5px" />
                                            <span>Caller Details</span>
                                        </Flexbox>
                                    </div>
                                    {owner && <div className="" style={{ padding: '20px' }}>
                                        <small style={{ letterSpacing: '3px', opacity: .5, fontSize: '8px' }}>FULL NAME</small>
                                        <div></div>
                                        <Typography>
                                            {owner.first_name} {owner.last_name}
                                        </Typography>
                                        <Spacebox padding="5px" />
                                        <small style={{ letterSpacing: '3px', opacity: .5, fontSize: '8px' }}>EMAIL ADDRESS</small>
                                        <div></div>
                                        <span>
                                            <a href={"mailto:" + owner.email}>{owner.email}</a>
                                        </span>
                                        <Spacebox padding="5px" />
                                        <small style={{ letterSpacing: '3px', opacity: .5, fontSize: '8px' }}>PHONE</small>
                                        <div></div>
                                        <span>
                                            {formatUSPhoneNumber(owner.phone)}
                                        </span>
                                    </div>}
                                </div>}
                            </Grid>
                        </div>
                    )}
                </Container>
            </div>
        </Mode>
    );
}

export default CallLogs;